export const columns = [
  {
    title: "节点名称",
    dataIndex: "currentNodeSnapshootName",
    width: 80,
    key: "currentNodeSnapshootName",
  },
  {
    title: "节点状态",
    dataIndex: "flowStatusDesc",
    width: 80,
    key: "flowStatusDesc",
  },
  {
    title: "审批意见",
    dataIndex: "remark",
    width: 80,
    key: "remark",
  },
  {
    title: "提交人",
    dataIndex: "createName",
    width: 80,
    key: "createName",
  },
  {
    title: "审批人（下一节点）",
    width: 80,
    dataIndex: "nextTenantUserRealName",
    key: "nextTenantUserRealName",
    slots: { customRender: "nextTenantUserRealName" },
  },
  {
    title: "提交时间",
    width: 80,
    dataIndex: "createTime",
    key: "createTime",
  },
];
